module.exports = __webpack_public_path__ + "img/landing-subscription-screen-1.b5fe55f4.png";